/** 预览态浮层挂 body + fixed；全屏态挂卡片根节点随卡片滚动 */
export type TCardOverlayProps = {
  popupContainer?: HTMLElement;
  positionFixed?: boolean;
};

export function getCardOverlayProps(
  isFullScreen: boolean,
  container: HTMLElement | null | undefined,
): TCardOverlayProps {
  if (isFullScreen && container) {
    return {
      popupContainer: container,
      positionFixed: false,
    };
  }
  return {
    positionFixed: true,
  };
}
